// ./src/components/lists/ListCalled/index.tsx
import React from 'react';

import { Paragraph, LoadingList } from '@components/index';
import Called from '@models/Called';
import { formatText } from '@utils/formatters';

import Item from './Item';

import { Container, Table, Labels, Items, NothingFound } from './styles';

interface IProps {
  calleds: Called[] | undefined;
  loading: boolean;
  showTotal: boolean;
  totalValue?: number;
}

const ListCalledProviders: React.FC<IProps> = ({
  calleds,
  loading,
  showTotal,
  totalValue,
}) => {
  return (
    <Container>
      <Table>
        <Labels>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            Solicitado
          </Paragraph>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            Atendido
          </Paragraph>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            Prestador
          </Paragraph>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            CPF/CNPJ
          </Paragraph>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            Telefone
          </Paragraph>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            PIX
          </Paragraph>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            Placa atendida
          </Paragraph>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            Total Kms
          </Paragraph>
          <Paragraph nameColor="black" textAlign="start" fontSize={12}>
            Valor do serviço
          </Paragraph>
          <Paragraph
            style={{ width: 90 }}
            nameColor="black"
            textAlign="start"
            fontSize={12}
          >
            Status
          </Paragraph>
        </Labels>
        <Items>
          {loading ? (
            <LoadingList loading={loading} />
          ) : (
            <>
              {calleds?.length === 0 ? (
                <NothingFound>
                  <Paragraph nameColor="black" opacity={0.6}>
                    Nenhum chamado foi encontrado
                  </Paragraph>
                </NothingFound>
              ) : (
                <>
                  {calleds?.map(called => (
                    <Item key={called.id} called={called} />
                  ))}
                </>
              )}
            </>
          )}
        </Items>
        {!loading && showTotal && (
          <Paragraph
            nameColor="black"
            textAlign="end"
            opacity={0.6}
            fontSize={12}
            style={{ margin: '1.5vh 0 0.5vh', fontWeight: 500 }}
          >
            {totalValue === 1
              ? '1 encontrado'
              : `${formatText.numberSeparatedByThousand(
                  totalValue || 0,
                )} encontrados`}
          </Paragraph>
        )}
      </Table>
    </Container>
  );
};

export default ListCalledProviders;
